import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from '@blueprintjs/core';
import { FloppyDisk } from '@blueprintjs/icons';
import { useProject } from '../project';

export const SaveButton = observer(() => {
  const project = useProject();

  const getButtonProps = () => {
    if (project.status === 'saving') {
      return {
        icon: <FloppyDisk className="rotating" />,
        text: 'Saving...',
        intent: 'none',
        fill: true,
        loading: true
      };
    }
    if (project.status === 'saved') {
      return {
        icon: <FloppyDisk />,
        text: 'Saved',
        intent: 'success',
        fill: true,
        loading: false
      };
    }
    return {
      icon: <FloppyDisk />,
      text: 'Save',
      intent: 'primary',
      fill: true,
      loading: false
    };
  };

  const handleSave = () => {
    project.requestSave();
  };

  return (
    <Button
      {...getButtonProps()}
      onClick={handleSave}
      style={{ marginRight: '10px' }}
    />
  );
}); 